import React, { useEffect, useState } from 'react';
import { JobDetail, JobDetailValueWithOption } from 'models';
import { Row, Slider, Stack, Text } from 'library/ui';
import MultiSelect from '../BusinessJobRequirementsPage/MultiSelect';
import SingleSelect from '../BusinessJobRequirementsPage/SingleSelect';
import { addOrRemoveDetail, addOrUpdateDetail } from 'parent-portal/forms/jobDetailMethods';
import { FormFieldProps } from '../../FormTypes';

export default function JobDetailInput({
    detail,
    jobDetails,
}: {
    detail: JobDetail;
    jobDetails: FormFieldProps<JobDetailValueWithOption[]>;
}) {
    const [selectedOptions, setSelectedOptions] = useState<JobDetailValueWithOption[]>([]);
    const [selectedOptionId, setSelectedOptionId] = useState<number>();
    const { value: values } = jobDetails;

    function toNumber(detail: JobDetail) {
        const val = getValue(detail);
        return val ? parseInt(val) : undefined;
    }

    function setNumber(value: number) {
        addOrUpdateDetail({ detail: detail.id, value: value.toString() }, jobDetails);
    }

    function getValue(detail: JobDetail) {
        return values.find((val) => val.detail === detail.id)?.value;
    }

    function getOption(detail: JobDetail) {
        const selected = values.find((val) => detail.id === val.detail);
        return detail.options.find((option) => option.id === selected?.option_id)?.id;
    }

    function setOption(optionId?: number) {
        addOrUpdateDetail({ detail: detail.id, option_id: optionId }, jobDetails);
    }

    useEffect(() => {
        if (detail.value_type === 'MULTI_SELECT') {
            const selected = values.filter((val) => val.detail === detail.id);
            setSelectedOptions(selected);
        } else if (detail.value_type === 'SINGLE_SELECT') {
            setSelectedOptionId(getOption(detail));
        }
    }, [values, detail]);

    return detail.value_type === 'NUMBER' ? (
        <Stack fullWidth padding="md" gap="sm">
            <Slider min={0} max={10} value={toNumber(detail) ?? 0} onChange={setNumber} />
            <Row justify="between" fullWidth>
                <Text size="sm" tone="secondary">
                    None Required
                </Text>
                <Text size="sm" tone="secondary">
                    10+
                </Text>
            </Row>
        </Stack>
    ) : detail.value_type === 'MULTI_SELECT' ? (
        <MultiSelect
            options={detail.options}
            selectedOptions={selectedOptions}
            onSelect={(optionId) => addOrRemoveDetail(jobDetails, detail, optionId)}
        />
    ) : detail.value_type === 'SINGLE_SELECT' ? (
        <SingleSelect value={selectedOptionId} onChange={setOption} options={detail.options} />
    ) : null;
}
